import '../../styles/buttons/headerStoreButton.scss';

type props = {
  onClick: (event: React.MouseEvent) => void;
  icon?: any;
  value?: string;
  classes?: string;
  loading?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  normal?: boolean;
  title?: string;
};

const HeaderStoreButton: React.FC<props> = ({
  onClick,
  icon,
  value,
  type,
  disabled,
  classes = '',
  normal,
  title,
}) => {
  let isNormalButton;
  if (normal) isNormalButton = 'true';
  else isNormalButton = 'false';
  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={'headerStoreButton' + (' ' + classes)}
      title={title}
    >
      {icon}
      <p>{value}</p>
    </button>
  );
};

export default HeaderStoreButton;
